import { ISignal } from 'shared/hooks/useAbortController';
import { requestService } from 'shared/utils/services/requestService';
// this function should be non-blocking
export default function logExposure({
  deviceId,
  experimentName,
  isAuthenticated,
  optionalMetaData,
  signal,
}: {
  deviceId: string;
  experimentName: string;
  isAuthenticated?: boolean;
  optionalMetaData?: {
    sessionId?: string;
    userId?: number;
  };
  signal: ISignal;
}) {
  // send logged_in & userId if existing
  const metaData = {
    user_type: isAuthenticated ? 'logged_in' : 'anonymous',
    ...optionalMetaData,
  };

  // only use deviceId and sessionId to describe the current user experience
  return requestService({
    url: `/web-api/darwin/log-exposure?experimentName=${experimentName}&clientId=${deviceId}`,
    method: 'POST',
    signal,
    data: {
      userLogTimestamp: Date.now().valueOf(),
      experimentLogMetaData: metaData,
    },
  });
}
